import React from 'react'
import { isMobile } from 'react-device-detect'
import DcOverlaySlider from '../dc-overlay-slider/dc-overlay-slider'

export interface MobileSliderProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  padding?: string
  width?: string
  loading?: boolean
  customWith?: string
  children?: React.ReactNode
}

// A thin wrapper around DcOverlaySlider that applies sensible mobile defaults
const MobileSlider: React.FC<MobileSliderProps> = ({
  isOpen,
  onClose,
  title,
  padding = '0px',
  width = '70%',
  loading,
  customWith,
  children,
}) => {
  return (
    <DcOverlaySlider
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      padding={padding}
      width={width}
      loading={loading}
      // On mobile, force full width unless a custom width is provided
      customWith={isMobile ? customWith || '100%' : customWith}
    >
      {children}
    </DcOverlaySlider>
  )
}

export default MobileSlider



